import { AppState } from 'app-redux/reducers';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';

import LegalDocumentsNavBar from '../../components/LegalDocumentsNavBar';
import { history, RoutePaths } from '../../core/history';
import { getSearchParam } from 'core/common-methods';
import { INavigationRouteProps } from 'core/navigation/models';
import { LegalDocumentsContent } from 'components/LegalDocumentsContent';
import { AvailableDocumentTypes } from 'utils/enums';
import './styles.less';

export type DocumentType = AvailableDocumentTypes.PRIVACY | AvailableDocumentTypes.TERMS;

interface ILegalDocuments extends INavigationRouteProps<{}> {
  countryKey: string;
}

const LegalDocuments = (props: ILegalDocuments) => {

  const defaultCountryKey = props.countryKey;
  const [currentCountry, setCurrentCountry] = useState(defaultCountryKey?.toUpperCase() ?? '');
  const currentDocumentType = getSearchParam(props.location.search, 'document_type') as DocumentType;
  const [documentTypeSelected, setDocumentTypeSelected] = useState<DocumentType>(currentDocumentType || AvailableDocumentTypes.TERMS);

  const redirectToCurrentCountryLegalDocsScreen = (currCountry: string) => {
    setCurrentCountry(currCountry);
    history.push(RoutePaths.LEGAL(currCountry));
  }

  return (
    <div className="legaldocs">
      <LegalDocumentsNavBar
        defaultCountry={defaultCountryKey}
        redirectToCurrentCountryLegalDocsScreen={redirectToCurrentCountryLegalDocsScreen}
        documentTypeSelected={documentTypeSelected}
        setDocumentTypeSelected={setDocumentTypeSelected}
        currentCountry={currentCountry}
      />
      <div className='legaldocs-content'>
        <LegalDocumentsContent
          currentCountry={currentCountry}
          documentTypeSelected={documentTypeSelected}
          redirectToCurrentCountryLegalDocsScreen={redirectToCurrentCountryLegalDocsScreen}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (_state: AppState, ownProps: any) => ({
  countryKey : get(ownProps, 'match.params.countryKey', null),
});

const mapDispatchToProps = (dispatch: any) => ({});

export const LegalDocumentsPage = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LegalDocuments),
);
